module.exports = __webpack_public_path__ + "img/hero-project-stella.06479bf.jpg";